// TODO: TRANSFER_FEE may differ by currency. Needs backend coordination when multi-currency ships.
export const TRANSFER_FEE = 1.7;
